import { Modal, Popover, Select, Cascader, Radio, Checkbox, Button, message, Progress } from "antd";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useIntl } from 'react-intl'
import { useSearchParams } from 'react-router-dom'
import MainContext from "@/stores/stores";
import styles from './index.module.scss'
import accountApi from "@/api/accountApi";
import { strEncrypt, getDecryptParams } from '@/utils/utils'
import listApi from "@/api/listApi";
import Pdfcon from "./Pdfcon";
import Carsearch from "@/pages/Carsearch";
import Hmcarsearch from "./Hmcarsearch";
import QRCode from 'qrcode';

const WOMALA_HOSTS = ["womala.maiqipei.com","womala.xiaomaiqipei.com","www.womalacarpart.com","womalacarpart.com"]

const Exportpart: React.FC<any> = (props) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const params: any = searchParams.get('params')
  const intl = useIntl()
  const includesHost = (origin: string, hosts: string[]) => hosts.some((host) => origin.includes(host))
  let origin = window.location.origin
  // 判断是否是森配
  let isSen = false
  let senPeiOption: any[] = [
    
  ]
  if(origin.includes("senp.maiqipei.com") || origin.includes("senp.xiaomaiqipei.com")) {
    isSen = true
    senPeiOption = [
      {
        header: intl.formatMessage({ id: '汽车厂商' }),
        key: 'cars_series',
        width: 20,
        num: [1, 2, 3]
      }
    ]
  }
  // 判断是否是恒铭网站
  let ishm = false
  if(origin.includes("webtest.maiqipei.com") || origin.includes("gzhmqy.maiqipei.com") || origin.includes("gzhmqy.com") || origin.includes("300")) {
    ishm = true
  }
  // 判断是否是沃玛拉
  let isWomala = includesHost(origin, WOMALA_HOSTS)

  let lang = window.localStorage.getItem('lang') || 'zh'

  const colOption = [
    {
      header: intl.formatMessage({ id: '图片' }),
      key: 'img',
      width: 10,
      num: [1, 2, 3]
    },
    {
      header: intl.formatMessage({ id: '产品名称' }),
      key: 'part_name',
      width: 15,
      num: [1, 2, 3]
    },
    {
      header: intl.formatMessage({ id: '原厂OE' }),
      key: 'quality_oe',
      width: 15,
      num: [1, 3]
    },
    {
      header: intl.formatMessage({ id: '产品编码' }),
      key: 'code',
      width: 15,
      num: [1, 2, 3]
    },
    {
      header: intl.formatMessage({ id: '品牌/品质' }),
      key: 'quality_name',
      width: 10,
      num: [1, 3]
    },
    {
      header: intl.formatMessage({ id: '质保时间' }),
      key: 'warranty',
      width: 10,
      num: [1]
    },
    {
      header: intl.formatMessage({ id: '销售价格' }),
      key: 'quality_price',
      width: 10,
      num: [1]
    },
    {
      header: intl.formatMessage({ id: '规格/参数' }),
      key: 'params',
      width: 20,
      num: [1, 3]
    },
    ...senPeiOption,
    // {
    //   header: intl.formatMessage({ id: '规格' }),
    //   key: 'spec',
    //   width: 20,
    //   num: [3]
    // },
    {
      header: intl.formatMessage({ id: '备注' }),
      key: 'remark',
      width: 15,
      num: [1, 2, 3]
    },
    {
      header: intl.formatMessage({ id: 'H5二维码' }),
      key: 'h5_url',
      width: 10,
      num: [1, 2, 3]
    }
  ]

  const { commonStore, setCommonStore } = useContext(MainContext)
  const { logo, canLang } = commonStore
  console.log(logo)
  const [open, setOpen] = useState<boolean>(false)
  const [fileType, setFileType] = useState<'excel' | 'pdf'>("excel")
  const [brandActive, setBrandActive] = useState<any>({value: '', label: ''})
  const [colSelect, setColSelect] = useState<any>(colOption.map((it: any) => it.key))
  const [classSelect, setClassSelect] = useState<any>([])
  const [classData, setClassData] = useState<any>([])
  const [brandOption, setBrandOption] = useState([])
  const [exportLoading, setExportLoading] = useState<boolean>(false)
  const [loading, setLoading] = useState(false)
  const [partList, setPartList] = useState<any[]>([])
  const fileOption = [
    {
      label: 'EXCEL',
      value: 'excel'
    },
    {
      label: 'PDF',
      value: 'pdf'
    }
  ]
  const [pdfopen, setPdfopen] = useState<boolean>(false)
  const [brandOpen, setBrandOpen] = useState<boolean>(false)
  const [fetchNum, setFetchNum] = useState<number>(0)

  const [shownum, setShownum] = useState<number>(ishm ? 2 : 1)
  const [exportPartLang, setExportPartLang] = useState("en")

  const [partnameData, setPartnameData] = useState<any>({})
  const [progress, setProgress] = useState<number>(0)
  const [exportProgress, setExportProgress] = useState<number>(0)
  const [is_cst, setIsCst] = useState(0)
  const [hmkey, setHmkey] = useState<number>(1)
  const isMountedRef = useRef(false)

  const langItems: any = [
    {
      value: 'zh',
      label: '中文',
    },
    {
      value: 'en',
      label: 'English'
    },
    {
      value: 'ru',
      label: 'Русский язык'
    },
    {
      value: 'cht',
      label: '中文-繁體'
    },
    {
      value: 'tr',
      label: 'Türkiye',
    },
    {
      value: 'ara',
      label: 'بالعربية'
    },
    {
      value: 'pt',
      label: 'Português'
    },
    {
      value: 'vie',
      label: 'Tiếng Việt'
    },
    {
      value: 'kor',
      label: '한국어'
    }
    /* {
      key: 'may',
      label: (
        <div className="flex-s-c" onClick={() => setLang('may')}>
          Bahasa Melayu
        </div>
      )
    },
    {
      key: 'th',
      label: (
        <div className="flex-s-c" onClick={() => setLang('th')}>
          ภาษาไทย
        </div>
      )
    },
    {
      key: 'id',
      label: (
        <div className="flex-s-c" onClick={() => setLang('id')}>
          Bahasa Indonesia
        </div>
      )
    },
    {
      key: 'pl',
      label: (
        <div className="flex-s-c" onClick={() => setLang('pl')}>
          Polski
        </div>
      )
    } */
  ].filter((item: any) => canLang && canLang.includes(item.value))

  useEffect(() => {
    getClassData()
    getBrandOption()
    getIsCst()

    return () => {
      isMountedRef.current = false
    }
  },[])

  useEffect(() => {
    if(!open) {
      setPartList([])
      setFetchNum(0)
      setBrandActive({})
      setClassSelect([])
      setHmkey(hmkey + 1)
      setLoading(false)
      isMountedRef.current = false
    }
  },[open])

  useEffect(() => {
    if(open && params && !ishm) {
      let carsInfo = getDecryptParams(params)
      setBrandActive({
        label: carsInfo.market_name,
        value: carsInfo.market_name,
        ...carsInfo
      })
      console.log(carsInfo)
      if(carsInfo.class) {
        let classArr = carsInfo.class.split(",")
        if(classArr.length === 1) {
          setClassSelect([classArr])
        } else {
          setClassSelect([[classArr[0], classArr[0] + '-' + classArr[1]]])
        }
      }
      setFetchNum(1)
    }
  },[open])

  useEffect(() => {
    if(fetchNum) {
      getData()
    }
  },[fetchNum])

  useEffect(() => {
    isMountedRef.current = false
    setLoading(false)
    setProgress(0)
    setPartList([])
  },[brandActive, classSelect])

  const getIsCst = () => {
    accountApi.getIsCst().then((res: any) => {
      if(res.code === 1) {
        setIsCst(res.data.is_cst)
      }
    })
  }


  const getBrandOption = () => {
    accountApi.getSelectBrandList().then((res: any) => {
      if(res.code === 1) {
        let _option: any = []
        try {
          res.data.cars_brands.all_brands.brands.forEach((item: any) => {
            item.brands.forEach((brand: any) => {
              _option.push({
                label: brand.brand_name,
                value: brand.key,
                ...brand
              })
            })
          })
        }catch {

        }
        setBrandOption(_option)
      }
    })
  }
  const getClassData = () => {
    accountApi.getSecondClass({is_hide: 1}).then((res: any) => {
      if(res.code === 1) {
        let standard_subgroup_name = res.data.standard_subgroup_name || {}
        let _option = Object.keys(standard_subgroup_name).map((key) => {
          return {
            label: key,
            value: key,
            children: standard_subgroup_name[key].map((it: any) => ({ label: key + '-' + it, value: key + '-' + it }))
          }
        })
        setClassData(_option)
      }
    })
  }

  const get_label_name = () => {
    let _label_name: any = []
    classSelect.forEach((items: any) => {
      items.forEach((item: any) => {
        if(items.length === 1) {
          _label_name.push(item)
        }else {
          if((item.split('-').length === 2)) {
            _label_name.push(item.split('-')[1])
          }
        }
      })
    })
    return _label_name.join(",")
  }
  const getData = () => {
    let _label_name = get_label_name()
    console.log(_label_name)
    if(!_label_name && !(brandActive.cars_id || brandActive.brand_name)) {
      message.warning(intl.formatMessage({ id: "请先选择车型或者分类" }))
      return false
    }
    setLoading(true)
    // setProgress(0)
    const pageSize = 200
    let currentPage = 1
    let allList: any[] = []
    isMountedRef.current = true
    const fetchData = () => {
      if(!isMountedRef.current) return
      console.log(brandActive)
      listApi.getPdfPartlist({
        page: currentPage,
        size: pageSize,
        is_cst,
        cars_id: brandActive.cars_id,
        brand: brandActive.cars_id ? undefined : brandActive.brand_name,
        brandCode: brandActive.brandCode,
        stype: brandActive.cars_id ? "cars" : 'category',
        label_name: _label_name || undefined,
        pdf_export: 'pdf'
      }).then((res: any) => {
        if(!isMountedRef.current) return
        if(res.code === 1) {
          let total = res.data.total || 0
          let page = res.data.page || currentPage
          let size = res.data.size || pageSize
          const list = res.data.list || []
          allList = allList.concat(list)
          setProgress(total ? Math.min(Math.floor((allList.length / total) * 100), 95) : 95)
          
          if(page * size < total) {
            currentPage++
            fetchData()
          } else {
            processAllData(allList)
          }
        } else {
          setLoading(false)
          setPartList([])
        }
      }).catch((err: any) => {
        isMountedRef.current = false
        setProgress(0)
        setLoading(false)
        setPartList([])
      })
    }

    const processAllData = (list: any[]) => {
      const buildMainGroupDict = (data: any[]) => {
        let mainGroupDict: any = {}
        let orderIndex = 0
        classData.forEach((item: any) => {
          const mainGroup = item.value || item.label
          if(mainGroup && mainGroupDict[mainGroup] === undefined) {
            mainGroupDict[mainGroup] = orderIndex++
          }
        })
        data.forEach((item: any) => {
          const mainGroup = item.main_group || ''
          if(mainGroupDict[mainGroup] === undefined) {
            mainGroupDict[mainGroup] = orderIndex++
          }
        })
        return mainGroupDict
      }

      const getMerchantPartsList = (data: any[]) => {
        let formatCodeMap: any = {}
        let merchantPartsList: any[] = []
        data.forEach((item: any) => {
          const currentItem = {
            ...item,
            codes: [item.code]
          }
          const formatCode = item.format_code
          const hasFormatCode = formatCode !== undefined && formatCode !== null && formatCode !== ''
          if(hasFormatCode) {
            const formatCodeKey = String(formatCode)
            const existIndex = formatCodeMap[formatCodeKey]
            if(existIndex !== undefined) {
              const existItem = merchantPartsList[existIndex]
              existItem.codes = [...existItem.codes, item.code]
              if(!existItem.images && currentItem.images) {
                existItem.images = currentItem.images
              }
            } else {
              formatCodeMap[formatCodeKey] = merchantPartsList.length
              merchantPartsList.push(currentItem)
            }
          } else {
            merchantPartsList.push(currentItem)
          }
        })

        const mainGroupDict = buildMainGroupDict(merchantPartsList)
        console.log(mainGroupDict)
        return merchantPartsList.sort((a: any, b: any) => {
          const aMainGroupOrder = mainGroupDict[a.main_group || '']
          const bMainGroupOrder = mainGroupDict[b.main_group || '']
          if(aMainGroupOrder !== bMainGroupOrder) {
            return aMainGroupOrder - bMainGroupOrder
          }
          return String(a.codes?.[0] || '').localeCompare(String(b.codes?.[0] || ''))
        })
      }

      const merchantPartsList = getMerchantPartsList(list)
      let codeList = merchantPartsList.map((item: any) => {
        return {
          code: item.code,
          brand_names: item.brand_names
        }
      })
      
      if(codeList.length > 0) {
        const pricePageSize = 200
        let priceCurrentPage = 0
        let allPriceData: any = {}
        let priceTotal = codeList.length

        const fetchPriceData = () => {
          const priceBatch = codeList.slice(priceCurrentPage * pricePageSize, (priceCurrentPage + 1) * pricePageSize)
          listApi.getNewPartListPrice({
            goods_codes: priceBatch,
            warranty: 1
          }).then((res1: any) => {
            if(res1.code === 1) {
              allPriceData = { ...allPriceData, ...res1.data }
              setProgress(Math.min(95 + Math.floor(((priceCurrentPage + 1) * pricePageSize) / priceTotal * 5), 99))
              
              if((priceCurrentPage + 1) * pricePageSize < priceTotal) {
                priceCurrentPage++
                fetchPriceData()
              } else {
                let part_name_list: any = []
                let _list = merchantPartsList.map((item: any, i: number) => {
                  let params: any = ''
                  let product_params_obj = JSON.parse(item.product_params || '{}')
                  params = Object.keys(product_params_obj).map((key) => `${key}:${product_params_obj[key]};`).join("")
                  if(isSen) {
                    params = Object.keys(product_params_obj).filter((key: any) => key === 'cars').map((key) => `${product_params_obj[key]}`).join("")
                  }
                  part_name_list.push(item.part_name)
                  return {
                    ...item,
                    quality_oe: item.oe,
                    ...allPriceData[item.code],
                    img: item.images ? item.images.split(',')[0] : (item.oe_image_info && item.oe_image_info.imagePath ? item.oe_image_info.imagePath : `https://cdns.007vin.com/img/autorepair/cst/no_item.png`),
                    index: i + 1,
                    params,
                    quality_price: allPriceData[item.code]?.quality_price ? allPriceData[item.code]?.quality_price : intl.formatMessage({ id: '待报价' })
                  }
                })
                setPartList(_list)
                getPartLang(part_name_list)
                setLoading(false)
                setProgress(100)
              }
            } else {
              setLoading(false)
            }
          }).catch((err: any) => {
            setLoading(false)
          })
        }

        fetchPriceData()
      } else {
        setLoading(false)
        setPartList(merchantPartsList)
        setProgress(100)
      }
    }

    fetchData()
  }
  const getPartLang = (part_name_list: any) => {
    let params = {
      to_language: langItems.map((it: any) => it.value === 'zh' ? 'cn' : it.value).join(","),
      part_name_list
    }
    listApi.getPartLang(params).then((res: any) => {
      if(res.code === 1) {
        setPartnameData(res.data)
      }
    })
  }
  

  async function generateExcelWithImages() {
    // const statusElement = document.getElementById('status');
    // statusElement.textContent = '正在生成Excel文件...';
    if(!partList.length || loading) {
      message.warning(intl.formatMessage({ id: '请先搜索导出数据' }))
      return false
    }
    setExportLoading(true)
    let _window: any = window
    try {
        // 创建工作簿和工作表
        const workbook = new _window.ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('产品列表');

        let maincolumns: any = colOption.filter((it: any) => {
          // if(shownum === 1) return colSelect.includes(it.key)
          // if(shownum === 2) {
          //   return it.num === 2 && colSelect.includes(it.key)
          // } 
          return it.num.includes(shownum) && colSelect.includes(it.key)
        })
        let imgIndex = maincolumns.findIndex((it: any) => it.key === 'img')
        if(lang !== exportPartLang && (shownum === 2 || true)) {
          let i = maincolumns.findIndex((it: any) => it.key === 'part_name')
          if(i !== -1) {
            maincolumns.splice(i + 1, 0, {
              header: intl.formatMessage({ id: '产品名称' }),
              key: 'other_part_name',
              width: 15,
              // num: 2
            })
          }
          if(brandActive.market_name) {
            maincolumns.push({
              header: intl.formatMessage({ id: '车型' }),
              key: 'car',
              width: 15,
              // num: 2
            })
          }
          if(brandActive.market_name || get_label_name()) {
            maincolumns.push({
              header: intl.formatMessage({ id: '分类' }),
              key: 'main_group',
              width: 15,
              // num: 2
            })
          }
        }

        // maincolumns.push({
        //   header: intl.formatMessage({ id: '备注' }),
        //   key: 'remark',
        //   width: 15,
        // })
        // maincolumns.push({
        //   header: intl.formatMessage({ id: 'H5二维码' }),
        //   key: 'h5_url',
        //   width: 10,
        // })
        let h5_url_index = maincolumns.findIndex((it: any) => it.key === 'h5_url')

        // 设置列宽
        worksheet.columns = [
            {header: intl.formatMessage({ id: '序号' }), key: 'index', width: 5},
            ...maincolumns
        ];

        // 设置表头样式
        worksheet.getRow(1).font = { bold: true };
        worksheet.getRow(1).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'CCCCCC' }
        };

        // 示例数据
        const products: any = partList
        console.log(products)
        let uArr = Array.from({ length: 26 }, (_, i) => String.fromCharCode(65 + i))
        // 填充数据和图片
        for (let i = 0; i < products.length; i++) {
            if(i % 10 === 0 && (imgIndex !== -1 || h5_url_index !== -1)) {
              setExportProgress(parseInt((i / products.length) * 100 as any))    
            }
            const product = products[i];
            const rowIndex = i + 2; // 从第2行开始（第1行是表头）
            
            // 设置行高以适应图片
            worksheet.getRow(rowIndex).height = 50;
            if(rowIndex === 1) {
              worksheet.getCell(`A${rowIndex}`).fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "CCCCCC" },
              };
            }
            

            // 填充文本数据
            // worksheet.getCell(`A${rowIndex}`).value = product.id;
            // worksheet.getCell(`B${rowIndex}`).value = product.name;
            // worksheet.getCell(`D${rowIndex}`).value = product.description;
            
            worksheet.columns.forEach((item: any, index: number) => {
              // console.log(item)
              if(item._key !== 'img' && item._key !== 'h5_url') {
                if(shownum === 2 || true) {
                  if(item._key === 'other_part_name') {
                    let la = exportPartLang === 'zh' ? 'cn' : exportPartLang
                    worksheet.getCell(`${uArr[index]}${rowIndex}`).value = partnameData[product['part_name']] ? partnameData[product['part_name']][la] : '';
                  }else if(item._key === 'car') {
                    worksheet.getCell(`${uArr[index]}${rowIndex}`).value = showTitle()
                  }else if(item._key === 'cars_series') {
                    worksheet.getCell(`${uArr[index]}${rowIndex}`).value = product[item._key] ? product[item._key].join(";") : '' 
                  } else {
                    worksheet.getCell(`${uArr[index]}${rowIndex}`).value = product[item._key];
                  }
                  
                }else {
                  worksheet.getCell(`${uArr[index]}${rowIndex}`).value = product[item._key];
                }
              }
            })
            if(imgIndex !== -1) {
              // 下载并插入图片
                try {
                  const response = await fetch(product.img);
                  const blob = await response.blob();
                  const arrayBuffer = await blob.arrayBuffer();
                  
                  // 将图片添加到工作簿
                  const imageId = workbook.addImage({
                      buffer: arrayBuffer,
                      extension: 'png', // 根据实际图片类型调整
                  });

                  // 将图片插入到单元格
                  worksheet.addImage(imageId, {
                      tl: { col: 1, row: rowIndex - 1 }, // C列（索引2），行索引从0开始
                      ext: { width: 50, height: 50 } // 图片尺寸
                  });
              } catch (error) {
                  console.error(`插入图片${product.name}失败:`, error);
                  worksheet.getCell(`C${rowIndex}`).value = '图片加载失败';
              }
            }

            if(product.h5_url && h5_url_index !== -1) {
              // 下载并插入图片
                try {
                  const base64 = await QRCode.toDataURL(product.h5_url, {
                    width: 200,
                    margin: 1,
                    color: {
                      dark: '#000000',
                      light: '#ffffff',
                    },
                  });
                  const response = await fetch(base64);
                  const blob = await response.blob();
                  const arrayBuffer = await blob.arrayBuffer();
                  
                  // 将图片添加到工作簿
                  const imageId = workbook.addImage({
                      buffer: arrayBuffer,
                      extension: 'png', // 根据实际图片类型调整
                  });

                  // 将图片插入到单元格
                  worksheet.addImage(imageId, {
                      tl: { col: h5_url_index + 1, row: rowIndex - 1 }, // C列（索引2），行索引从0开始
                      ext: { width: 50, height: 50 } // 图片尺寸
                  });
              } catch (error) {
                  console.error(`插入图片${product.name}失败:`, error);
                  worksheet.getCell(`C${rowIndex}`).value = '图片加载失败';
              }
            }

        }

        // 生成文件并下载
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        _window.saveAs(blob, ((brandActive.market_name || "") + `${classSelect.length && brandActive.market_name ? ' - ': ''}` + get_label_name()) + '.xlsx');
        setExportLoading(false)
        setExportProgress(0)
        message.success(intl.formatMessage({ id: '导出成功' }))
        // statusElement.textContent = 'Excel文件生成成功！';
    } catch (error) {
        setExportLoading(false)
        setExportProgress(0)
        console.error('生成Excel失败:', error);
        // statusElement.textContent = '生成失败: ' + error.message;
    }
  }

  const showTitle = () => {
    let result = ''
    if(brandActive.market_name) {
      let market_name_arr = brandActive.market_name.split(">")
      if((market_name_arr[3] && market_name_arr[3].includes(",")) || (market_name_arr[4] && market_name_arr[4].includes(","))) {
        result = market_name_arr.slice(0,3).join(">")
      }else {
        result = brandActive.market_name
      }
    }else {
     result = brandActive.brand_name || ""
    }
    return result  
  }
  return (
    <>
      {/* <Popover
        placement="left"
        trigger="click"
        content={
          <div>
            <div className="pointer">{intl.formatMessage({ id: 'Excel格式' })}</div>
            <div className="pointer mt5">{intl.formatMessage({ id: 'Pdf格式' })}</div>
          </div>
        }
      >
        <div className="flex-c-c ptb5 pointer" style={{ flexDirection: 'column', borderTop: '1px solid #00000033', width: '100%', color: '#000000', background: "#fff" }}>
          <i className="iconfont icon-Vector" />
          {intl.formatMessage({ id: '导出' })}
        </div>
      </Popover> */}
      <div onClick={() => setOpen(true)} className="flex-c-c ptb5 pointer" style={{ flexDirection: 'column', width: '100%', color: '#000000', background: "#fff" }}>
        <i className="iconfont icon-Vector" />
        {intl.formatMessage({ id: '导出' })}
      </div>
      
      <Modal
        title={intl.formatMessage({ id: '自定义导出列' })}
        open={open}
        onCancel={() => setOpen(false)}
        width={900}
        footer={null}
        // okText={intl.formatMessage({ id: '导出' })}
        // okButtonProps={{
        //   loading: loading || exportLoading
        // }}
        // onOk={() => exportData()}
      >
        <div>
          {/* <div className="flex-s-c mt10">
            <label style={{ width: 120 }}>{intl.formatMessage({ id: '文件类型' })}</label>
            <Radio.Group
              style={{ flex: 1 }}
              options={fileOption}
              value={fileType}
              onChange={(e) => setFileType(e.target.value)}
            >
            </Radio.Group>
          </div> */}
          <div className="flex-b-c">
            <div className="p10" style={{ flex: 1, border: '1px solid #00000033' }}>
              <div className="flex-s-c">
                <label style={{ width: 120 }}>{intl.formatMessage({ id: '品牌/车型' })}</label>
                <div className="flex-1 flex-s-c">
                  <Select 
                    allowClear
                    filterOption={(input: any, option: any) =>
                      (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                    }
                    showSearch
                    placeholder={intl.formatMessage({ id: '品牌' })}
                    style={{ flex: 1 }} 
                    value={brandActive.key}
                    options={brandOption}
                    onChange={(value, option: any) => {
                      if(value) {
                        setBrandActive({...option, brandCode: option?.brandCode, key: value})
                      }else {
                        setBrandActive({})
                      }
                    }}
                  />
                  <Button onClick={() => setBrandOpen(true)}>{intl.formatMessage({ id: '选择车型' })}</Button>
                </div>
              </div>
              {
                brandActive.market_name ? (
                  <div className="flex-s-c mt5">
                    <label style={{ width: 120, opacity: 0 }}>{intl.formatMessage({ id: '品牌/车型' })}</label>
                    <div className="flex-1 flex-s-c">
                      {brandActive.market_name} <i onClick={() => setBrandActive({})} className=" ml10 pointer red icon-shanchu iconfont"/>
                    </div>
                  </div>
                ): null
              }
              <div className="flex-s-c mt10">
                <label style={{ width: 120 }}>{intl.formatMessage({ id: '分类' })}</label>
                <Cascader 
                  placeholder={intl.formatMessage({ id: '选择分类' })}
                  style={{ flex: 1 }}
                  options={classData}
                  multiple
                  onChange={(value) => {setClassSelect(value); console.log(value)}}
                  value={classSelect}
                />
              </div>
            </div>
            <div className="flex-s-c" style={{ justifyContent: 'flex-end' }}>
              
              <Button loading={loading} onClick={() => getData()} type="primary" >{intl.formatMessage({ id: '搜索' })}</Button>
              {
                progress !== 0 && progress !== 100 ? (
                  <Progress className="ml5" percent={progress} type="circle" size={20} />
                ): null
              }
            </div>
          </div>
          <span className="mr10 mt10">{intl.formatMessage({ id: '总共' })}：{partList.length}</span>
          
          
          
          <div className="mt10" style={{ border: '1px solid #00000033' }}>
            <div className="p10" style={{ borderBottom: '1px solid #00000033', backgroundColor: '#f6f6f6' }}>
              {
                intl.formatMessage({ id: '选择需要导出的列' })
              }
              <Radio.Group
                className="ml20"
                options={
                  [
                    {
                      label: intl.formatMessage({ id: '样式1' }),
                      value: 1
                    },
                    {
                      label: intl.formatMessage({ id: '样式2' }),
                      value: 2
                    },
                    {
                      label: intl.formatMessage({ id: '样式3' }),
                      value: 3
                    },
                  ]
                }
                value={shownum}
                onChange={(e) => setShownum(e.target.value)}
              >
              </Radio.Group>
            </div>
            <div className="plr10 ptb5">
              {
                colOption.filter(it => it.num.includes(shownum)).map((item) => {
                  // if(shownum === 2 && item.num !== 2) return null
                  return (
                    <div className="flex-s-c mtb5">
                      <Checkbox
                        className="mr5"
                        checked={colSelect.includes(item.key)}
                        onClick={() => {
                          let text = item.key
                          let _colSelect = JSON.parse(JSON.stringify(colSelect))
                          let i = _colSelect.indexOf(text)
                          if(i !== -1) {
                            _colSelect.splice(i, 1)
                          }else {
                            _colSelect.push(text)
                          }
                          setColSelect(_colSelect)
                        }}
                      />
                      {item.header}
                    </div>
                  )
                })
              }
              <div className="mt10">
                <label>{intl.formatMessage({ id: '选择零件名称的语言' })}：</label>
                <Radio.Group
                  className="ml20"
                  options={
                    langItems
                  }
                  value={exportPartLang}
                  onChange={(e) => setExportPartLang(e.target.value)}
                >
                </Radio.Group>
              </div>
              
            </div>
          </div>
          <div className="flex-b-c mt20">
            <div>
              {
                exportProgress > 0 ? (
                  <Progress percent={exportProgress} style={{ width: 300 }} />
                ): null
              }
            </div>
            <div>
              <Button onClick={() => setOpen(false)} className="mr10">{intl.formatMessage({ id: '关闭' })}</Button>
              <Button loading={exportLoading} onClick={() => generateExcelWithImages()} className="mr10" type="primary">{intl.formatMessage({ id: '导出(Excel)' })}</Button>
              <Button onClick={() => {
                if(partList.length) {
                  setPdfopen(true)
                }else {
                  message.warning(intl.formatMessage({ id: '请先搜索导出数据' }))
                }
              }} type="primary">{intl.formatMessage({ id: '预览(Pdf)' })}</Button>
            </div>
          </div>
        </div>
      </Modal>
      {
        pdfopen ? (
          <Pdfcon
            inlogo={logo}
            list={partList}
            setOpen={(value: boolean) => setPdfopen(value)}
            colSelect={colSelect}
            title={
              (showTitle() || "") +
              `${classSelect.length && showTitle() ? ' - ': ''}` + get_label_name()
            }
            dph={brandActive.market_name ? (brandActive.market_name.split(">")[ishm ? 2 : 3] || "") : ""}
            partnameData={partnameData}
            partlangkey={exportPartLang !== 'zh' ? exportPartLang : 'cn'}
            shownum={shownum}
          />
        ): null
      }

      <Modal
        open={brandOpen}
        onCancel={() => setBrandOpen(false)}
        footer={null}
        width={1200}
        wrapClassName={styles['car-brand-search']}
        destroyOnClose={ishm ? true : true}
      >
        
        {
          ishm || isSen || isWomala ? (
            <Hmcarsearch
              key={brandActive.brandCode}
              carInfo={brandActive}
              setCarInfo={(data: any) => {setBrandActive(data); }}
              setOpen={setBrandOpen}
            />
          ): (
            <Carsearch
              from='list'
              carInfo={brandActive}
              setCarInfo={(data: any) => {setBrandActive(data); }}
              setOpen={setBrandOpen}
              isexport
            />
          )
        }
        
      </Modal>
    </>
    
    
  )
}

export default Exportpart
